// extracted by mini-css-extract-plugin
module.exports = {"announcements":"P_fx p-2","announcement":"P_fy card my-2","announcement--highlighted":"P_fz","announcement__list-item":"P_fB py-1","announcement__flag":"P_fC"};